import * as React from 'react';

import { CreditCalculationLayout, RdPathLoader } from '@neo.tax/rd/organisms';
import { Path } from '@neo.tax/shared';

import { useCreditCalculationRedirect } from './hooks';

export const CreditCalculation = (): React.ReactElement => (
  <RdPathLoader path={Path.CREDIT_CALCULATION} useRedirect={useCreditCalculationRedirect}>
    <CreditCalculationLayout />
  </RdPathLoader>
);
